import React, { useEffect } from "react";
import { Navigation, Nosotros, Footer, PageSEO } from "@/App";

const Empresa = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <PageSEO
        title="Empresa | AYCES - Despacho Actuarial con 30+ años de experiencia"
        description="Conoce a AYCES, despacho actuarial en México especializado en estudios actuariales, valuación actuarial de pasivos laborales y cálculo actuarial de pensiones."
        path="/empresa/"
      />
      <Navigation />
      <main className="pt-20">
        <Nosotros />
      </main>
      <Footer />
    </>
  );
};

export default Empresa;
